( function( global, $, grFormUpload) {

    $(document).on('click', '.js-add-furniture, .js-remove-furniture, .js-copy-applicant-fields', function (e) {
        e.preventDefault();
    });

    $('.service-call-form').on('click', '.js-remove-furniture', function () {
        $(this).parents('.furniture-template').remove();
    });

    $('.service-call-form').on('click', '.js-copy-applicant-fields', function () {
        var serviceCallForm = $('.service-call-form')

        updateRepairManField($('#customerProvince'));

        $('input[id*="customer"]').each(function() {
            var field = $(this);
            var id = field.attr('id').replace('customer', '');
            serviceCallForm.find('input[id*="shipping' + id + '"]').val(field.val());
        });

        $('select[id*="customer"]').each(function() {
            var field = $(this);
            var id = field.attr('id').replace('customer', '');
            var typeAttribute = field.data('type-attribute');
            var selectedValue;

            if (typeAttribute !== undefined) {
                selectedValue = field.find(':selected').data(typeAttribute);
                serviceCallForm.find('select[id*="shipping' + id + '"]').find('[data-' + typeAttribute + '="' + selectedValue + '"]').prop({ selected: true }).change();
            } else {
                selectedValue = field.find(':selected').val();
                serviceCallForm.find('select[id*="shipping' + id + '"]').val(selectedValue).change();
            }
        });
    });

    function updateRepairManField(el) {
        var elValue = el.find(':selected').val(),
            repairManField = $('#repairmanRequired');

        if (elValue === "Québec" || elValue === "Quebec") {
            repairManField.attr('disabled', false);
        } else {
            repairManField.attr('disabled', true);
            repairManField.prop("checked", false);
        }
    }


    var provinceValueSender = $('#shippingProvince'),
        shippingCountry = $('#shippingCountry'),
        isQuoteRevisionTrigger = $('#isQuoteRevision'),
        isQuoteRevisionTarget = $('#previousQuoteNumber'),
        isOrderRepetitionTrigger = $('#isOrderRepetition'),
        isOrderRepetitionTarget = $('#orderReferenceNumber');

    activateField(isQuoteRevisionTrigger, isQuoteRevisionTarget, $('.gr-form__field'), true);
    activateField(isOrderRepetitionTrigger, isOrderRepetitionTarget, $('.gr-form__field'), true);
    activateField(shippingCountry, provinceValueSender, $('.gr-form__field'), true);

    function activateField(trigger, target, container, isRequired) {

        if ( trigger && target && container ) {

            var parent = $(target).closest(container);

            trigger.on('change', function() {

                if ( trigger.is(':checked') || trigger.val() && trigger.is("select") ) {
                    parent.removeClass('is-disabled');

                    if (isRequired) {
                        target.attr('required', true);
                    }
                } else {
                    parent.addClass('is-disabled');
                    target.val("");

                    if (isRequired) {
                        target.removeAttr('required');
                    }
                }
            });
        }
    }

    if ( provinceValueSender) {
        provinceValueSender.on('change', function () {
            updateRepairManField(provinceValueSender)
        });
    }

    var $form_tooltip = $('[form-tooltip]');

    if ($form_tooltip ) {
        initializeTooltip($form_tooltip);
    }

    function initializeTooltip($element) {
        $element.magnificPopup({
            type: 'image',
            closeOnContentClick: true,
            mainClass: 'mfp-img-mobile',
            image: {
                verticalFit: true
            }
        });
    }

    var furnitureTrigger = document.querySelector('.js-add-furniture'),
        furniture = document.querySelector('.furniture-template'),
        firstFurnitureContainer = document.querySelector('#first-furniture'),
        furnitureContainer = document.querySelector('#other-furnitures'),
        furnitureIndex = 0;

    if (furnitureTrigger) {
        furnitureTrigger.addEventListener('click', addFurniture);
    }

    if ($('.service-call-form').length > 0) {
        addFurniture();
    }

    function addFurniture() {
        var lastFurniture;

        if (furnitureIndex == 0) {
            firstFurnitureContainer.appendChild(furniture.cloneNode(true));
            lastFurniture = $('#first-furniture .furniture-template:last-child');
            lastFurniture.find('.furniture-remove-link').addClass('is-hidden');
        } else {
            furnitureContainer.appendChild(furniture.cloneNode(true));
            lastFurniture = $('#other-furnitures .furniture-template:last-child');
        }

        lastFurniture.removeClass('is-hidden');

        matrixLineItem(lastFurniture, furnitureIndex);

        var $lineItemType = lastFurniture.find('[type=hidden]');
        $lineItemType.attr('name', $lineItemType.attr('name').replace('[new]', '[' + furnitureIndex + ']'));
        lastFurniture.find('.parsley-error').removeClass('parsley-error');

        var fileInputs = lastFurniture[0].querySelectorAll('input[type="file"]');
        if (fileInputs !== null) {
            var globIndex;
            var fileInput;

            for (var index = 0; index < fileInputs.length; index++) {
                fileInput = fileInputs[index];

                if ( global.plugins.grFormUpload.instances !== undefined ) {
                    globIndex = Object.keys(global.grFormUpload.instances).length;
                } else {
                    global.grFormUpload = { instances: {} };
                    globIndex = 0;
                }

                global.grFormUpload.instances[globIndex] = new grFormUpload(fileInput);
            }
        }

        furnitureIndex++;
    }

    function matrixLineItem(item, index) {
        var fileIndex = 1;

        item.find('.js-attribute').each(function() {
            var lineItem = $(this);

            var $tooltip = lineItem.children('a.form-tooltip');
            if ($tooltip.length > 0) {
                initializeTooltip($tooltip);
            }

            lineItem.removeClass('js-attribute');

            var input = lineItem.find('input, textarea');
            var name = input.attr('id');
            var isFileInput = input.attr('type') === 'file-template';

            // Label
            var id = name + furnitureIndex;

            if (isFileInput) {
                input.attr('type', input.attr('type').replace('-template', ''));
                id += '-' + fileIndex;
                fileIndex++;
            }

            lineItem.find('[for=' + name + ']').attr('for', id);

            // Input
            input
                .attr('id', id)
                .attr('name', input.attr('name').replace('[new]', '[' + index + ']'))
                .val('')
                .removeAttr('data-parsley-id').next().remove();
        });
    }

}( window.groots, jQuery, require('../../garden/buds/grFormUpload/grFormUpload') ));
